import { tns } from 'tiny-slider/src/tiny-slider.module.js';

export function heroSlider(el) {
    const element = document.querySelector(el);
    // zoek in de parent div naar de slider navigation
    const prev =  element && element.parentNode.querySelector('.prev');
    const next = element && element.parentNode.querySelector('.next');

    const slider = tns({
        container: el,
        controls: false,
        nav: false,
        lazyload: false,
        autoplay: true,
        mouseDrag: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 7500,
    });

    prev && prev.addEventListener('click', () => slider.goTo('prev'));
    next && next.addEventListener('click', () => slider.goTo('next'));
}